import { isDefined } from "../server/lib/common";

export const versions = {
	v1_0_0: "v1.0.0", // 2022年リリース当初のバージョン
	v2_0_0: "v2.0.0", // 2025年のrelease: 調査票変更したversion
	v3_0_0: "v3.0.0", // 2026年のrelease: アルゴリズム解説書version2
} as const;

export const latestVersion = versions.v3_0_0;

export const isLatestVersion = (version: string | undefined): boolean => version === latestVersion;

export const isOver3Version = (version: string | undefined): boolean => {
	if (!isDefined(version)) return false;
	const match = version.match(/^v(\d+)\.\d+\.\d+$/);
	if (!match) return false;
	const num = Number(match[1]);
	return num >= 3;
};
